import { render, staticRenderFns } from "./OrdiniMTMCards.vue?vue&type=template&id=128505ce"
import script from "./OrdiniMTMCards.vue?vue&type=script&lang=ts"
export * from "./OrdiniMTMCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128505ce')) {
      api.createRecord('128505ce', component.options)
    } else {
      api.reload('128505ce', component.options)
    }
    module.hot.accept("./OrdiniMTMCards.vue?vue&type=template&id=128505ce", function () {
      api.rerender('128505ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/OrdiniMTMCards.vue"
export default component.exports